module.exports = __webpack_public_path__ + "img/sort-icon-1.a7579b1e.png";